"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// resources/js/components/common/InfiniteScrollContainer.tsx
var react_1 = __importDefault(require("react"));
var react_infinite_scroll_component_1 = __importDefault(require("react-infinite-scroll-component"));
var material_1 = require("@mui/material");
var Lang_js_1 = require("../../Lang.js");
var InfiniteScrollContainer = function (_a) {
    var dataLength = _a.dataLength, hasMore = _a.hasMore, loadMore = _a.loadMore, children = _a.children;
    return (react_1.default.createElement(react_infinite_scroll_component_1.default, { dataLength: dataLength, next: loadMore, hasMore: hasMore, scrollThreshold: "200px", loader: react_1.default.createElement("div", { className: "results-loading-container" },
            react_1.default.createElement(material_1.CircularProgress, { className: "results-spinner" }),
            react_1.default.createElement("p", { className: "results-loading-text" }, (0, Lang_js_1.__)('Loading more...'))) }, children));
};
exports.default = InfiniteScrollContainer;
